import logo from '@@assets/imgs/logo.png';
import clx from '@@components/page/home/clx';
import LocaleSwitcher from '@@components/utils/LocaleSwitcher';
import { useFormatter, useTranslations } from 'next-intl';
import Image from 'next/image';

/**
 * Component: TitleSection
 */
const TitleSection = () => {
  const t = useTranslations();
  const format = useFormatter();

  return (
    <section className={clx('title-section')}>
      <Image
        src={logo} //
        alt="logo"
        priority={true}
        placeholder="blur"
        draggable={false}
        unselectable="on"
        quality={100}
        className={clx('logo-image')}
      />
      <LocaleSwitcher />
      <div className="mx-auto lg:w-3/4 xl:w-2/4">{t('title_text')}</div>
      <div className="mx-auto w-fit rounded-md bg-green-700 px-3 py-2 font-bold uppercase text-white">
        {/* shadow-[0_0_.75rem_.2rem_var(--tw-shadow-color)] shadow-green-700 */}
        <p>apartman / night</p>
        <hr />
        <p>{format.number(30000, { style: 'currency', currency: 'HUF', maximumFractionDigits: 0 })}</p>
        <p>{format.number(100, { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 })}</p>
      </div>
    </section>
  );
};
export default TitleSection;
